// added new code  .... 30/05/2025 ... temporary modal page  comments 25/06/2025.. it is working akash and badybash model file code both 2 pop-up 

// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { closeIcon } from '../../constants/iconImageConstant';
// import '../../App.scss';

// export const CustomModal: React.FC = () => {
//   const [show, setShow] = useState(false);
//   const [currentImage, setCurrentImage] = useState(1);

//   const images = [
//     {
//       src: 'https://mybb.etvbalbharat.com/banners/popo-up-final-akasa.jpg',
//       // src: 'https://assets.etvbalbharat.com/banners/popo-up-final-copy-01.jpg',
//     },
//     {
//        src: 'https://mybb.etvbalbharat.com/banners/homepagepopup.jpg',
//       // src: 'https://assets.etvbalbharat.com/banners/popo-up-final-copy-2.jpg',
//     }
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShow(true);
//       setCurrentImage(0);
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   const handleClose = () => {
//     if (currentImage === 0) {
//       setCurrentImage(1);
//     } else {
//       setShow(false);
//     }
//   };

//   useEffect(() => {
//     if (currentImage === 1) {
//       setShow(true);
//     }
//   }, [currentImage]);

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       animation={true}
//       centered
//       className={`custom-modal ${show ? 'show' : 'hide'}`}
//     >
//       <Modal.Body>
//         <div className="close-btn float-right" role="button" onClick={handleClose} tabIndex={0}>
//           <img src={closeIcon} loading="lazy" alt="close" width="30px" height="30px" />
//         </div>
//         <div style={{ textAlign: 'center', margin: '0px' }}>
//           <img
//             src={images[currentImage].src}
//             width="100%"
//             alt="Popup"
//             loading="lazy"
//           />
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };




// Added new Pop-up code 11/08/2026 chandrakant M MG


import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { closeIcon } from '../../constants/iconImageConstant';
// import '../../App.scss';

export const CustomModal: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={true}
      centered
      className={`custom-modal ${show ? 'show' : 'hide'}`}
    >
      <Modal.Body>
        <div
          className="close-btn float-right"
          role="button"
          onClick={handleClose}
          tabIndex={0}
        >
          <img
            src={closeIcon}
            loading="lazy"
            alt="close"
            width="30px"
            height="30px"
          />
        </div>

        <div style={{ textAlign: 'center', margin: '0px' }}>
          <img
            src="https://mybb.etvbalbharat.com/banners/homepagepopup.jpg"
            width="100%"
            alt="Popup"
            loading="lazy"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};




// old code comments 30/05/2025 ... 10:32AM ,,  working   permanent modal page that always shows on page load,
// Diwali sheddule working there popup 

// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { closeIcon } from '../../constants/iconImageConstant';
// import '../../App.scss'; 

// export const CustomModal: React.FC = () => {
//   const [show, setShow] = useState(false);
//   const [imageSrc, setImageSrc] = useState('');

//   useEffect(() => {
//     const showTimer = setTimeout(() => {
//       setShow(true);
//     }, 1000);

//     const hideTimer = setTimeout(() => {
//       setShow(false);
//     }, 5100);

//     return () => {
//       clearTimeout(showTimer);
//       clearTimeout(hideTimer);
//     };
//   }, []);
  
//   useEffect(() => {
//     const today = new Date();
//     const day = today.getDate();
//     const month = today.getMonth(); 

//    console.log(month);
//     if ((month === 9 && day >= 27) || (month === 10 && day <= 14)) {
//       setShow(true);
//       setImageSrc('https://mybb.etvbalbharat.com/rangoli/images/pop-up.png'); 
//     } else {
//       setShow(true);
//       setImageSrc('https://mybb.etvbalbharat.com/banners/homepagepopup.jpg');
//     }
//   }, []);

//   const handleClose = () => setShow(false);

//   const handleImageClick = () => {
//     if (imageSrc.includes('rangoli/images/pop-up.png')) {
//       window.location.assign('https://mybb.etvbalbharat.com/rangoli/index.php');
//     } else if (imageSrc.includes('banners/homepagepopup.jpg')) {

//       window.location.assign('https://mybb.etvbalbharat.com/kids_birthdates_2023/contest2.php');
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       animation={true}
//       centered
//       className={`custom-modal ${show ? 'show' : 'hide'}`} 
//     >
//       <Modal.Body>
//         <div className="close-btn float-right" role="button" onClick={handleClose} tabIndex={0}>
//           <img src={closeIcon} alt="close" width="30px" height="30px" />
//         </div>
//         <div style={{ textAlign: "center", margin: "0px" }}>
      
//           <button onClick={handleImageClick} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
//             <img
//               src={imageSrc}
//               width="100%"
//               alt="Diwali Rangowali"
            
//             />
//           </button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };





















// added new code with akash new modal images showing.... 26/06/2025....12:07 PM ,

// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { closeIcon } from '../../constants/iconImageConstant';
// import '../../App.scss';

// export const CustomModal: React.FC = () => {
//   const [show, setShow] = useState(false);
//   const [currentImage, setCurrentImage] = useState(0);

//   const images = [
//     {
//       src: 'https://mybb.etvbalbharat.com/banners/popo-up-final-copy-4-d.jpg',
//     },
//     {
//       src: 'https://mybb.etvbalbharat.com/banners/homepagepopup.jpg',
//     }
//   ];

//   useEffect(() => {
//     // Show modal with first image after 100ms
//     const openTimer = setTimeout(() => {
//       setShow(true);
//       setCurrentImage(0);
//     }, 200);

//     // Change to second image after 5 seconds
//     const changeImageTimer = setTimeout(() => {
//       setCurrentImage(1);
//     }, 5100); // wait 5s after first

//     return () => {
//       clearTimeout(openTimer);
//       clearTimeout(changeImageTimer);
//     };
//   }, []);

//   const handleClose = () => {
//     setShow(false);
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       animation={true}
//       centered
//       className={`custom-modal ${show ? 'show' : 'hide'}`}
//     >
//       <Modal.Body>
//         <div
//           className="close-btn float-right"
//           role="button"
//           onClick={handleClose}
//           tabIndex={0}
//         >
//           <img src={closeIcon} loading="lazy" alt="close" width="30px" height="30px" />
//         </div>
//         <div style={{ textAlign: 'center', margin: '0px' }}>
//           <img
//             src={images[currentImage].src}
//             width="100%"
//             alt="Popup"
//             loading="lazy"
//           />
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };
